<!-- 语言设置 -->
<script setup>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import i18n from "@/i18n"
import { onMounted, watch, ref } from "vue";
import { getLangData, setLangData, getLangDetailByKey, getLangMenu } from "@/service/apiList/lang.js"
import { showMessage } from "@/utils/hooks/message"
import addCom from "./add.vue";
const title = i18n.global.t("menu.system_management")
const items = [
    {
        text: title,
    },
    {
        text: i18n.global.t("menu.lang"),
        active: true,
    },
]
// 菜单
const menuList = ref([])
// 语言JSON数据
const langJsonData = ref({});
// 当前显示的模板
const moduleKey = ref('menu'); //默认的
// 当前显示的列表
const tableAllData = ref([]); // 当前所有的数据
const tableData = ref([]); // 当前包含搜索条件的数据
const keyword = ref('') //查询
const showEdit = ref(false) // 进入编辑状态
const visible = ref(false) // 是否可新增  对于用户来说没啥用 只有开发者有用
const formData = ref({
    key: '',
    ch: '',
    en: '',
    description: '',
})
// methods

// const makeData = (d_object, key = '') => {
//     for (const item in d_object) {
//         if (typeof d_object[item].ch != 'undefined' && typeof d_object[item].en != 'undefined') {
//             let item_obj = {
//                 key: key ? `${key}${item}` : item,
//                 ch: d_object[item].ch,
//                 en: d_object[item].en,
//             }
//             tableAllData.value.push(item_obj)
//         } else {
//             makeData(d_object[item], key ? `${key}${item}.` : `${item}.`)
//         }

//     }
// }
const setData = () => {
    // // 根据json数据获取key的数据
    // tableAllData.value = []
    // let d_object = langJsonData.value.find(item => item.key == moduleKey.value);
    // if (d_object?.value) {
    //     tableAllData.value = [...d_object.value]
    // }
    // 获取
    if (tableAllData.value.length) {
        // 看看条件
        filterData();
    } else {
        tableAllData.value = []
        tableData.value = []
    }
}

const filterData = () => {
    // 数据过滤
    if (keyword.value) {
        tableData.value = tableAllData.value.filter(item => `${item.name}`.includes(keyword.value.trim())
            || `${item.name_en}`.includes(keyword.value.trim())
            || `${item.description}`.includes(keyword.value.trim())
            || `${item.key}`.includes(keyword.value.trim())
        )
    } else {
        tableData.value = [...tableAllData.value];
    }
}

// const setValueByPath = (obj, path, ch, en) => {
//     const keys = path.split('.'); // 将路径字符串拆分为数组
//     let current = obj;

//     // 遍历路径层级，定位到目标对象
//     for (let i = 0; i < keys.length - 1; i++) {
//         const key = keys[i];

//         // 如果路径中间的对象不存在，则创建一个新对象
//         if (!current[key]) {
//             current[key] = {};
//         }
//         current = current[key];
//     }

//     // 设置最终层级的值
//     current[keys[keys.length - 1]].ch = ch;
//     current[keys[keys.length - 1]].en = en;
// }

const getData = async (type = 0) => {
    // 获取JSON数据
    const reps = await getLangData();
    if (reps.code === 0) {
        langJsonData.value = reps.payload;
        if (type == 1) {
            sessionStorage.setItem("custom-lang", JSON.stringify(reps.payload));
        }
    }
}

const submit = async () => {
    // 提交数据
    let object = [...tableAllData.value]
    for (const item in tableData.value) {
        // 设置数据
        const { key, name, name_en, description } = tableData.value[item]
        let index = object.findIndex(item => item.key === key)
        if (index > -1) {
            object[index].name = name
            object[index].name_en = name_en
        }else{
            object.push({
                key,
                name,
                name_en,
                description
            })
        }
    }
    // 开始提交数据
    const resp = await setLangData(moduleKey.value, { value: object });
    if (resp.code === 0) {
        showMessage('success', i18n.global.t("base.edit_success"))
        // 关闭编辑状态
        showEdit.value = false;
        getData(1); // 刷新数据

    } else {
        showMessage('danger', resp.message,)
    }

}

const _getLangDetailByKey = async () => {
    // 滚动条回到顶部位置
    let dom = document.querySelector('#scrollBar')
    dom.scrollTop = 0
    // 获取字典信息
    const resp = await getLangDetailByKey(moduleKey.value)
    if (resp.code === 0) {
        tableAllData.value = resp.payload.value;
        setData();
    } else {
        showMessage('danger', resp.message,)
    }
}

const _getLangMenu = async () => {
    // 获取左侧菜单
    const resp = await getLangMenu();
    if (resp.code === 0) {
        menuList.value = resp.payload;
        _getLangDetailByKey();
    } else {
        showMessage('danger', resp.message,)
    }
}

const submitForm = ()=> {
    // 提交信息
    if(formData.value.key =='' || formData.value.ch == '' || formData.value.en == '') {
        showMessage('danger', i18n.global.t("base.requiredinformation"));
        return;
    }
    // 新增数据
    tableData.value.push({
        key: formData.value.key,
        name: formData.value.ch,
        name_en: formData.value.en,
        description: formData.value.description,
    });
    submit();
    // 关闭新增状态
    visible.value = false;
}

// 加载完成
onMounted(() => {
    _getLangMenu();
})
watch(moduleKey, () => {
    //监听menu key改变
    _getLangDetailByKey();
})
watch(keyword, () => {
    filterData();
})
</script>
<template>

    <Layout>
        <PageHeader :title="title" :items="items" />
        <div style="height: calc(100vh - 160px); " class=" d-flex">
            <div class="me-4   card bg-white" style="flex: 2; height: 100%;">
                <!-- <div class="header p-2">{{ $t('lang.functional_classification') }}</div> -->
                <div class="w-100 ps-4"
                    style="background-color: #E2E8ED; min-height: 40px;  padding-left: 20px;font-size: 16px;padding: 15px 0px 15px 20px;">
                    {{ $t("lang.functional_classification") }}</div>
                <div class="my-scroll-bar overflow-auto " style="height:calc(100% - 54px);">
                    <div style="font-size: 14px;">
                        <div v-for="(item, k) in menuList" :key="k" class="my-2 px-4 py-2 cursor-pointer"
                            :class="item.key == moduleKey ? 'active' : ''" @click="moduleKey = item.key">
                            {{ i18n.global.locale == 'en' ? item.name_en : item.name }}
                        </div>
                    </div>
                </div>

            </div>
            <div class="bg-white card  d-flex" style="flex: 8; flex-direction: column; height: 100%;">
                <div class="header1 py-2 px-3 d-flex align-items-center justify-content-between">
                    {{menuList.length ? i18n.global.locale == 'en' ? menuList.find(item => item.key ==
                        moduleKey)?.name_en : menuList.find(item => item.key == moduleKey)?.name : ''}}
                    <div v-if="!showEdit" class="d-flex">
                        <b-button class="mx-2" variant="success" @click="showEdit = true"
                            v-permit="'system-management.language-configuration.modify'"
                            style="width: 104px; background-color: #0AB39C;display: flex; align-items: center;justify-content: center; width: 100px; height: 37px;border-color: unset; justify-content: center;">
                            <i class=" ri-edit-box-line ri me-2" style="font-size: 16px;"></i>{{ $t('base.edit1') }}
                        </b-button>
                        <div style="display: none;">
                        <b-button class="mx-2" variant="success" @click="visible = true"
                            v-permit="'system-management.language-configuration.modify'"
                            style="width: 104px; background-color: #0AB39C;display: flex; align-items: center;justify-content: center; width: 100px; height: 37px;border-color: unset; justify-content: center;">
                            <i class=" ri-edit-box-line ri me-2" style="font-size: 16px;"></i>{{ $t('base.add') }}
                        </b-button>
                        </div>
                    </div>

                    <div class="d-flex align-items-center justify-content-center" v-else>
                        <button @click="showEdit = false" type="button" class="btn btn-light"
                            style="min-width: 70px; height: 37px;">{{
                                $t('base.cancel') }}</button>
                        <b-button class="mx-2" variant="success" @click="submit"
                            style="min-width: 70px; height: 37px;background-color: #0AB39C;border-color: unset;">
                            {{ $t('base.confirm') }}
                        </b-button>
                    </div>
                </div>
                <div class="d-flex" style="flex-direction:column; flex: 1; height: calc(100% - 70px)">
                    <div class="form-icon my-3 ms-3" style="width: 580px;">
                        <input clearable type="text" class="form-control form-control-icon" v-model="keyword"
                            :placeholder="$t('lang.search')" />
                        <i class="ri-search-line"></i>
                    </div>
                    <!-- 列表 -->
                    <div style="flex: 1; height: calc(100% - 37.5px - 2rem);">
                        <div class="d-flex align-items-center"
                            style="height: 44px; background-color: #F3F6F9; color: #9599AD; font-size: 14px;">
                            <div style="flex: 1; width: 22%;" class="ps-3">{{ $t('lang.key') }}</div>
                            <div style="flex: 1; width: 22%;" class="ps-3">{{ $t('lang.description') }}</div>
                            <div style="flex: 1; width: 22%;" class="ps-3">{{ $t('lang.ch') }}</div>
                            <div style="flex: 1; width: 22%;" class="ps-3">{{ $t('lang.en') }}</div>
                        </div>
                        <div class="my-scroll-bar" id="scrollBar" style="overflow-y: auto;height: calc(100% - 44px);">
                            <template v-if="tableData.length">
                                <div v-for="(item, k) in tableData" :key="k" class="d-flex align-items-center"
                                    style="min-height: 40px;border-bottom: 1px solid #E9EBEC;">
                                    <div style="flex: 1;width: 22%; white-space: normal; word-break: break-all;"
                                        class="ps-3">{{ item.key }}</div>
                                    <div style="flex: 1;width: 22%; white-space: normal; word-break: break-all;"
                                        class="ps-3">{{ item.description || '-' }}</div>
                                    <div style="flex: 1;width: 22%; white-space: normal; word-break: break-all;"
                                        class="ps-3">
                                        <textarea class="form-control" v-model="item.name" v-if="showEdit"></textarea>
                                        <span v-else>{{ item.name }}</span>
                                    </div>
                                    <div style="flex: 1;width: 22%; white-space: normal; word-break: keep-all;"
                                        class="ps-3">
                                        <textarea class="form-control" v-model="item.name_en"
                                            v-if="showEdit"></textarea>
                                        <span v-else>{{ item.name_en }}</span>
                                    </div>
                                </div>
                            </template>
                            <div v-else class="d-flex align-items-center justify-content-center h-100">
                                <Empty />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <addCom v-if="visible" v-model:visible="visible" :width="800">
            <span class="text-danger">开发者使用，快捷新增字典，用户无开放必要0.0</span>
            <div class="form-icon my-3">
                <div><span class="text-danger">*</span>{{ $t('lang.key') }}</div> 
                <input type="text" class="form-control" v-model="formData.key"
                    :placeholder="$t('lang.key')" />
            </div>
            <div class="form-icon my-3">
                <div><span class="text-danger">*</span>{{ $t('lang.ch') }}</div> 
                <input type="text" class="form-control" v-model="formData.ch"
                    :placeholder="$t('lang.ch')" />
            </div>
            <div class="form-icon my-3">
                <div><span class="text-danger">*</span>{{ $t('lang.en') }}</div> 
                <input type="text" class="form-control" v-model="formData.en"
                    :placeholder="$t('lang.en')" />
            </div>
            <div class="form-icon my-3">
                <input type="text" class="form-control" v-model="formData.description"
                    :placeholder="$t('lang.description')" />
            </div>
            <div class="d-flex justify-content-end my-3">
                <b-button class="mx-2" variant="danger" @click="visible = false">{{ $t('base.cancel') }}</b-button>
                <b-button class="mx-2" variant="primary" @click="submitForm">{{ $t('base.confirm') }}</b-button>
            </div>
        </addCom>
    </Layout>
</template>
<style lang="scss" scoped>
.header {
    min-height: 38px;
    font-weight: bold;
    font-size: 16px;
    // border-bottom: 1px dashed #E9EBEC;
}

.header1 {
    height: 70px;
    font-weight: bold;
    font-size: 16px;
    border-bottom: 1px dashed #E9EBEC;
}

.active {
    background-color: #F3F6F9;
    color: #9599AD;
}
</style>